// extracted by mini-css-extract-plugin
export var content = "Button-module--content--59539";
export var hasTextWeightBold = "Button-module--has-text-weight-bold--f68bf";
export var isUppercase = "Button-module--is-uppercase--3aa3e";
export var root = "Button-module--root--88ef3";
export var secondary = "Button-module--secondary--9bc82";